export interface ResponseError {
  code?: string,
  property?: string,
  message?: string,
}

export interface ApiResponse<T = unknown> {
  isValid: boolean;
  data: T;
  errors: ResponseError[];
}

export function isApiResponse(obj: unknown): obj is ApiResponse {
  if (typeof obj !== 'object' || !obj) return false;

  const isValid = Object.getOwnPropertyDescriptor(obj, 'isValid');
  const hasData = Object.hasOwn(obj, 'data');
  const hasErrors = Object.hasOwn(obj, 'errors');

  return typeof isValid?.value === 'boolean' && hasData && hasErrors;
}

export function isApiResponseInvalid(obj: unknown): obj is ApiResponse & { isValid: false } {
  return isApiResponse(obj) && !obj.isValid;
}

export function isApiResponseValid(obj: unknown): obj is ApiResponse & { isValid: true } {
  return isApiResponse(obj) && obj.isValid;
}

export interface ApiResponseMetadata<T = unknown> extends ApiResponse<T>{
  metadata: {
    duration: number;
  };
}